import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ticketService } from '../api/ticketService';
import {
  MASTER_DATA_KEYS,
  masterDataQueryOptions,
  extractMasterDataArray,
} from '../lib/masterDataQuery';

/**
 * Session-cached ticket statuses from GET /gateway/api/ticket/statuses.
 * @param {{ enabled?: boolean }} [options]
 */
export function useStatuses(options = {}) {
  const { enabled = true } = options;

  const query = useQuery({
    queryKey: MASTER_DATA_KEYS.statuses,
    queryFn: () => ticketService.getTicketStatuses(),
    ...masterDataQueryOptions,
    enabled,
  });

  const data = useMemo(
    () => extractMasterDataArray(query.data),
    [query.data]
  );

  return {
    ...query,
    data,
    response: query.data,
  };
}

export default useStatuses;
